//@ts-nocheck
//@ts-ignore
import {
  applySnapshot,
  cast,
  flow,
  getEnv,
  getParent,
  getSnapshot,
  types,
} from "mobx-state-tree";
import BookingStore from "./bookingStore";
import ChildrenStore from "./children";
import FilterStore from "./filter";
import LessonScheduleStore from "./lessonSchedule";
import LocationFieldStore from "../location";
import ParentFormStore from "./parentForm";
import SearchResultType from "./searchResult";
import ServerRequestInfo from "./serverRequestInfo";
import TeacherSelectStore from "./teacherSelect";
import { splitSchedule, transformInput, transformOutput } from "./utils/misc";

const SubjectStore = types.model("Subjects", {
  name: types.string,
  shortName: types.string,
  isPreselected: types.boolean,
});
const PurposeStore = types.model("Purposes", {
  name: types.string,
  description: types.string,
  subjects: types.optional(types.array(SubjectStore), []),
});

const AcademicDataStore = types.model("AcademicData", {
  name: types.string,
  purposes: types.array(PurposeStore),
});

export const LessonScheduleListStore = types
  .model("LessonScheduleListStore", {
    clientSchedule: types.optional(types.array(LessonScheduleStore), []),
  })
  .views((self) => {
    return {
      display(index) {
        let options = ["First", "Second", "Third", "Fourth", "Fifth"];
        return options[index] || "";
      },
      get inputValue() {
        return self.clientSchedule.length > 0
          ? getSnapshot(self.clientSchedule)
          : [];
      },
      get isPopulated() {
        return self.clientSchedule.length > 0;
      },
      get isValid() {
        return (
          self.clientSchedule.length > 0 &&
          self.clientSchedule.every((schedule) => {
            return schedule.lessonDays.length > 0;
          })
        );
      },
    };
  })
  .actions((self) => {
    let parent: any = getParent(self, 1);
    const onSubmitForm = flow(function* submitForm(data) {
      // let transformedOutput = transformOutput(data);
      // self.childDetails = cast(transformedOutput);
      yield parent.onSubmit({ ...data, ...self.inputValue });
    });

    const initializeStore = (
      splitCount,
      defaultSchedule = {},
      splitRequest = []
    ) => {
      if (splitRequest.length > 1) {
        self.clientSchedule = cast(
          splitRequest.map((request) => ({
            ...request,
            lessonDuration: defaultSchedule.lessonDuration,
            lessonUrgency: defaultSchedule.lessonUrgency,
          }))
        );
      } else {
        self.clientSchedule = cast(
          new Array(splitCount).fill({
            ...defaultSchedule,
          })
        );
      }
    };
    return {
      initializeStore,
      onSubmitForm,
      updateSchedule(data, index) {
        self.clientSchedule.forEach((child, i) => {
          if (i === index) {
            applySnapshot(child, { ...getSnapshot(child), ...data });
          }
        });
      },
      addNewChild(data) {
        self.clientSchedule.push(data);
      },
      removeLastChild() {
        self.clientSchedule.pop();
      },
      replaceData(index, data) {
        self.clientSchedule.forEach((child, i) => {
          if (i === index) {
            applySnapshot(child, data);
          }
        });
      },
      remove(index) {
        self.clientSchedule = cast(
          self.clientSchedule.filter((x, i) => i !== index)
        );
      },
      updateDurationUrgency({ lessonDuration, lessonUrgency }) {
        const updatedSchedule = getSnapshot(self.clientSchedule).map(
          (schedule) => ({
            ...schedule,
            lessonDuration,
            lessonUrgency,
          })
        );
        self.clientSchedule = cast(updatedSchedule);
        parent.lessonScheduleStore.updateFields({
          lessonDuration,
          lessonUrgency,
        });
      },
    };
  });

export const RequestFlowStore = types
  .model("RequestRootStore", {
    childStore: types.optional(ChildrenStore, {}),
    teacherSelectStore: types.optional(TeacherSelectStore, {}),
    lessonScheduleStore: types.optional(LessonScheduleStore, {}),
    academicDataStore: types.optional(types.array(AcademicDataStore), []),
    lessonLocationStore: types.optional(LocationFieldStore, {}),
    contactInfoStore: types.optional(ParentFormStore, {}),
    scheduleStore: types.optional(LessonScheduleListStore, {}),
    bookingInfo: types.maybe(BookingStore),
    loading: types.optional(types.boolean, false),
    filterStore: types.optional(FilterStore, {}),
    sendingToClient: types.optional(types.boolean, false),
    slug: types.optional(types.string, ""),
    isAdminLogin: types.optional(types.boolean, false),
    isLoggedIn: types.optional(types.boolean, false),
    selectedTutors: types.optional(
      types.array(
        types.union(
          types.maybe(SearchResultType),
          types.maybeNull(SearchResultType)
        )
      ),
      []
    ),
    serverInfo: types.optional(ServerRequestInfo, {}),
    splitToExclude: types.optional(types.array(types.number), []),
  })
  .views((self) => {
    return {
      get splitInfo() {
        console.log("Split info", self.splitRequests);
        return self.splitRequests.map((o) => ({
          subjectGroup: o.subjectGroup,
          searchSubject: o.searchSubject,
          students: o.names,
        }));
      },
      get customerType() {
        return self.lessonLocationStore.customerType;
      },
      get bookedDate() {
        return self.serverInfo?.tutorResponseInfo?.bookingStage?.bookedDate;
      },

      get jobInfo() {
        let { contactDetails, lessonDetails } = this.requestData;
        let lessonSchedule = {
          ...(self.serverInfo?.tutorRequestInfo?.lessonDetails ||
            lessonDetails.lessonSchedule),
        };
        if (!lessonSchedule.lessonTime) {
          lessonSchedule.lessonTime = lessonDetails.lessonSchedule.lessonTime;
        }
        if (!lessonSchedule.lessonDuration) {
          lessonSchedule.lessonDuration =
            lessonDetails.lessonSchedule.lessonDuration;
        }
        if (!lessonSchedule.lessonHours) {
          lessonSchedule.lessonHours = lessonDetails.lessonSchedule.lessonHours;
        }
        console.log(lessonSchedule);
        return {
          requestSLUG: self.slug,
          requestStatus: self.serverInfo?.status,
          dateCreated: self.serverInfo?.created,
          searchSubject: self.serverInfo?.tutorRequestInfo?.searchSubject,
          customerInfo: contactDetails,
          students: self.serverInfo?.tutorRequestInfo?.individualTeacherArray,
          lessonInfo: {
            ...lessonSchedule,
            // ...lessonDetails.lessonSchedule,
            lessonType: lessonDetails.lessonType,
            lessonDays: self.serverInfo?.tutorRequestInfo
              ? getSnapshot(self.serverInfo?.tutorRequestInfo?.lessonDays)
              : [],
          },
          bookingStage: self.serverInfo.tutorResponseInfo.bookingStageSummary,
          billingInfo: self.serverInfo.bookingInfo,
          assignedSupport: {
            contactName: self.serverInfo.agent.name,
            contactPhone: self.serverInfo.agent.phone_number,
          },
          tutorResponse: self.serverInfo.tutorResponseInfo
            ? getSnapshot(self.serverInfo.tutorResponseInfo)
            : { status: "" },
        };
      },
      get teacherKind() {
        return self.teacherSelectStore.teacherOption;
      },
      get requestData() {
        // will need to speak with Godwin on the explanation of these fields. could also check sample data
        let {
          vicinity,
          state,
          region,
          country,
          address,
          lessonType,
          customerType,
        } = self.lessonLocationStore.asJSON;
        let childDetails = transformOutput({
          childDetails: getSnapshot(self.childStore.childDetails),
        });
        return {
          childDetails,
          contactDetails: {
            ...self.contactInfoStore.fullData,
            vicinity,
            state,
            region,
            address,
            country,
            customerType,
          },
          subjectDetails: {},
          lessonDetails: {
            lessonType,
            lessonSchedule: self.lessonScheduleStore.fullData,
          },
          teacherKind: this.teacherKind,
          filters: getSnapshot(self.filterStore),
          slug: self.slug,
        };
      },
      get academicData() {
        let result = {};
        getSnapshot(self.academicDataStore).forEach((a) => {
          result[a.name] = { purposes: a.purposes };
        });
        return result;
      },
      get selectedTutorsIds() {
        return self.selectedTutors.map((o) => o?.userId || undefined);
      },
      getScheduleSplit(splitRequests = []) {
        let { lessonScheduleStore } = self;
        let newRequestSplit = splitRequests;
        if (splitRequests.length > 0 && !splitRequests[0].lessonHours) {
          if (lessonScheduleStore.lessonDays.length > 0) {
            let newSchedule = getSnapshot(lessonScheduleStore);
            newRequestSplit = splitSchedule(
              newSchedule,
              getSnapshot(lessonScheduleStore.lessonDays),
              splitRequests
            );
          }
        }
        if (
          newRequestSplit.length === self.scheduleStore.clientSchedule.length
        ) {
          console.log("Scheduling split");
          newRequestSplit = newRequestSplit.map((split, index) => {
            let {
              lessonDays,
              lessonHours,
              lessonTime,
              lessonDuration,
              lessonUrgency,
            } = self.scheduleStore.clientSchedule[index];
            return {
              ...split,
              lessonDays: getSnapshot(lessonDays),
              lessonHours,
              lessonTime,
              lessonDuration,
              lessonUrgency,
            };
          });
        }
        if (self.selectedTutors.length === newRequestSplit.length) {
          return newRequestSplit.map((o, i) => {
            let tutorInfo = self.selectedTutors[i];
            return {
              ...o,
              tutorId: tutorInfo?.userId || null,
              tutorData: tutorInfo ? getSnapshot(tutorInfo) : null,
            };
          });
        }
        return newRequestSplit.map(split => ({ ...split, selectedTutor: true }));
      },
      get withoutSchedule() {
        let { childStore, lessonScheduleStore } = self;
        return childStore.splitRequests.map((o, i) => ({
          ...o,
          curriculum: o.curriculum || [],
        }));
      },
      get splitRequests() {
        return this.getScheduleSplit(self.withoutSchedule);
      },
      get adminActions() {
        return [
          {
            label: "Send booking to client",
            value: "send_profile_to_client",
          },
          {
            label: "Notify tutors on new job",
            value: "notify_tutors_on_new_job",
          },
          {
            label: "Update speaking fee payment",
            value: "process_speaking_fee",
          },
          {
            label: "Update lesson fee payment",
            value: "process_bank_payment",
          },
        ];
      },
      get paymentInfo() {
        return {
          slug: self.slug,
          walletBalance: self.bookingInfo.walletBalance,
          tutors: self.bookingInfo.splitRequests.map(({ selectedTutor }) => ({
            userId: selectedTutor.userId,
            subject: selectedTutor.subject.shortSummary,
            newTutorDiscount: selectedTutor.newTutorDiscount,
            distance: selectedTutor.distance || 0,
            firstName: selectedTutor.firstName,
            lastName: selectedTutor.lastName,
            photo: selectedTutor.photo,
          })),
          tuitionFee: self.bookingInfo.tuitionFee,
          totalLessons: self.bookingInfo.totalLessons,
          totalDiscount: self.bookingInfo.totalDiscount,
          couponDiscount: self.bookingInfo.couponDiscount,
          distanceThreshold: self.bookingInfo.distanceThreshold,
          farePerKM: self.bookingInfo.farePerKM,
          currency: self.bookingInfo.currency,
          monthsPaid: self.bookingInfo.monthsPaid,
          discountRemoved: self.bookingInfo.discountRemoved,
          gatewayFee: self.bookingInfo.gatewayFee,
          timeSubmitted: self.bookingInfo.timeSubmitted,
          discountCode: self.bookingInfo.discountCode,
          actualAmountPaid: self.bookingInfo.actualAmountPaid,
        };
      },
    };
  })
  .actions((self) => {
    let { adapter } = getEnv(self);
    const ChildStoreSubmission = () => {
      return self.childStore.fullData;
    };
    const ChildrenScheduleSubmission = () => {
      return self.scheduleStore.inputValue;
    };
    const TeacherStoreSubmission = (data) => {
      self.teacherSelectStore.updateField(data);
      self.filterStore.updateData({
        gender: data?.gender || ["male", "female"],
      });
      let selectedTeachers = getSnapshot(self.teacherSelectStore);
      return { ...selectedTeachers, gender: data.gender };
    };
    const LessonScheduleSubmission = (data) => {
      self.lessonScheduleStore.updateFields(data);
      // update schedule store for now
      // if(self.lessonSchedul)
      let condition1 = self.teacherKind === "Specialized teachers";
      let condition2 = self.splitRequests.length > 1;
      let merged = condition1 && condition2;
      if (!merged) {
        self.scheduleStore.initializeStore(
          self.splitRequests.length,
          getSnapshot(self.lessonScheduleStore)
        );
      }
      return getSnapshot(self.lessonScheduleStore);
    };
    const LessonLocationSubmission = (data) => {
      self.lessonLocationStore.updateFields(data);
      let { vicinity, region, state, lessonType, country, address } =
        self.lessonLocationStore;
      return { vicinity, region, state, lessonType, country, address };
    };
    const ContactInfoSubmission = (data) => {
      self.contactInfoStore.updateField(data);
      let snapshot = getSnapshot(self.contactInfoStore);
      return snapshot;
    };
    const moveToNewScheduleFlow = () => {
      if (
        self.splitRequests.length != self.scheduleStore.clientSchedule.length
      ) {
        self.scheduleStore.initializeStore(
          self.splitRequests.length,
          getSnapshot(self.lessonScheduleStore),
          self.splitRequests
        );
      }
    };
    const onSubmit = flow(function* submitForm(key, formData?: any) {
      self.loading = true;
      try {
        let options = {
          "student-details": ChildStoreSubmission,
          "teacher-selection": TeacherStoreSubmission,
          "lesson-schedule": LessonScheduleSubmission,
          "lesson-location": LessonLocationSubmission,
          "contact-information": ContactInfoSubmission,
          "children-schedule": ChildrenScheduleSubmission,
        };
        let data = options[key](formData);
        let workingSplit = self.splitRequests.filter(
          (o, i) => !self.splitToExclude.includes(i)
        );
        let splitToExclude = self.splitRequests.filter((o, i) =>
          self.splitToExclude.includes(i)
        );
        yield adapter.onSubmit(key, data, workingSplit, splitToExclude); // remember to save to localstorage
        if (key == "teacher-selection") {
          moveToNewScheduleFlow();
        }
        if (key == "lesson-schedule") {
          let locationData = yield adapter.getCountries(
            self.lessonLocationStore.country,
            self.lessonLocationStore.state
          );
          self.lessonLocationStore.updateFields(locationData);
          // self.getScheduleSplit(self.splitRequests);
        }
        // if (key == "contact-information") {
        //   // let tutorsExists = yield adapter.checkIfTutorsExists({
        //   //   splitRequests: self.splitRequests,
        //   //   ...self.requestData,
        //   // });
        //   // self.loading = false;
        //   // self.splitToExclude = tutorsExists;
        //   let workingSplit = self.splitRequests.filter(
        //     (o, i) => !self.splitToExclude.includes(i)
        //   );
        //   let splitToExclude = self.splitRequests.filter((o, i) =>
        //     self.splitToExclude.includes(i)
        //   );
        //   yield adapter.onSubmit(key, data, workingSplit, splitToExclude); // remember to save to localstorage

        //   return self.splitToExclude;
        // }
        self.loading = false;
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });
    const getBookingInfo = flow(function* getBookingInfo(slug) {
      try {
        let result = yield adapter.getBookingInfo(slug);
        updateBookingInfo(result);
      } catch (error) {
        throw error;
      }
    });
    const updateBookingInfo = (result, oldSplit = []) => {
      let { tutors = [], ...rest } = result;
      let splitToWorkWith = oldSplit.length > 0 ? oldSplit : self.splitRequests;
      self.bookingInfo = BookingStore.create({
        ...rest,
        splitRequests: splitToWorkWith.map((split, index) => {
          let tutor = tutors[index];
          let other = {};
          if (tutor) {
            other.tutorData = tutor;
            // other.tutorId = tutor.
          }
          return {
            ...split,
            ...other,
            // selectedTutor: tutors[index]
          };
        }),
      });
      self.bookingInfo.updateBookingState();
    };
    const initializeRequestData = flow(function* initializeRequestData(
      academicData,
      useWhatsapp = false
    ) {
      let [requestData, tutorsData] = yield adapter.initializeRequestData();
      mapToStore(requestData, academicData, tutorsData, useWhatsapp);
    });
    const saveRequestToServer = flow(function* saveRequestToServer(
      isAdminLogin?: boolean,
      splitRequests?: any[]
    ) {
      try {
        self.loading = true;
        let slug = yield adapter.saveRequestToServer(
          isAdminLogin || self.isAdminLogin,
          self.slug,
          splitRequests
        );
        self.slug = slug;
        // self.loading = false;
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });
    function updateServerInfo({ agent, created, modified, status, ...rest }) {
      // self.serverInfo = ServerRequestInfo.create({
      //   agent,
      //   created,
      //   modified,
      //   status,
      // });
      applySnapshot(self.serverInfo, {
        agent,
        created,
        modified,
        status,
        ...rest,
      });
    }
    function mapToStore(
      rawData,
      academicData,
      previouslySelectedTutors = [],
      initializeWhatsapp = false
    ) {
      let oldData = getSnapshot(self);
      let {
        contactDetails = {},
        lessonDetails = {},
        childDetails = [],
        filters = {},
        clientSchedule = [],
        slug = "",
      } = rawData;
      const { phone, preferredComms = {} } = contactDetails;
      const whatsAppNumber = preferredComms;
      if (initializeWhatsapp) {
        if (Object.keys(preferredComms).length === 0) {
          whatsAppNumber.channel = "whatsapp";
          whatsAppNumber.number = phone;
        }
      }

      applySnapshot(self, {
        ...oldData,
        lessonLocationStore: {
          ...oldData.lessonLocationStore,
          lessonType:
            contactDetails.country !== "Nigeria"
              ? "online"
              : lessonDetails.lessonType,
          country: contactDetails.country,
          address: contactDetails.address,
          state: contactDetails.state,
          region:
            contactDetails.country == "Nigeria"
              ? contactDetails.region || ""
              : "",
          vicinity:
            contactDetails.country == "Nigeria"
              ? contactDetails.vicinity || ""
              : "",
          country_code: contactDetails.country_code,
          customerType: contactDetails.customerType,
        },
        lessonScheduleStore: {
          ...oldData.lessonScheduleStore,
          ...lessonDetails.lessonSchedule,
        },
        teacherSelectStore: initializeWhatsapp
          ? {}
          : {
              ...oldData.teacherSelectStore,
              teacherOption:
                rawData.teacherKind || oldData.teacherSelectStore.teacherOption,
            },
        childStore: {
          ...oldData.childStore,
          childDetails: transformInput(childDetails).childDetails,
        },
        contactInfoStore: {
          ...oldData.contactInfoStore,
          ...contactDetails,
          preferredComms: whatsAppNumber,
        },
        filterStore: filters,
        slug,
        selectedTutors: previouslySelectedTutors,
        academicDataStore: academicData
          ? Object.keys(academicData).map((o) => ({
              name: o,
              purposes: academicData[o].purposes,
            }))
          : [],
        scheduleStore: {
          clientSchedule: [
            ...getSnapshot(self.scheduleStore.clientSchedule),
            ...clientSchedule,
          ],
        },
      });
    }

    const sendSearchLink = flow(
      function* sendSearchLink(requestData, paymentInfo) {
        try {
          self.sendingToClient = true;
          yield adapter.sendSearchLink(requestData, paymentInfo);
          self.sendingToClient = false;
        } catch (error) {
          self.sendingToClient = false;
          throw error;
        }
      }
    );
    const sendRequestToClient = flow(function* sendRequestToClient(data = {}) {
      try {
        self.sendingToClient = true;
        yield adapter.sendCheckoutLink({ ...data }, self.slug);
        self.sendingToClient = false;
      } catch (error) {
        self.sendingToClient = false;
        throw error;
      }
    });

    const triggerAdminAction = flow(function* triggerAdminAction(action) {
      if (action === "send_profile_to_client") {
        yield sendRequestToClient("checkout");
      } else {
        try {
          self.sendingToClient = true;
          yield adapter.processAdminAction(
            self.slug,
            action,
            self.bookingInfo.totalTuition
          );
          self.sendingToClient = false;
        } catch (error) {
          self.sendingToClient = false;
          throw error;
        }
      }
    });
    const sendAccountDetailsToClient = flow(function* () {
      yield adapter.sendAccountDetailsToClient(self.slug);
    });

    return {
      moveToNewScheduleFlow,
      triggerAdminAction,
      updateServerInfo,
      sendAccountDetailsToClient,
      sendSearchLink,
      sendRequestToClient,
      updateBookingInfo,
      getBookingInfo,
      onSubmit,
      onUpdateSchedule(data, index) {
        console.log({ index });
        if (self.scheduleStore.clientSchedule.length === 0) {
          self.scheduleStore.initializeStore(
            self.splitRequests.length,
            getSnapshot(self.lessonScheduleStore)
          );
        }
        if (self.splitRequests.length == 1) {
          LessonScheduleSubmission(data);
        }
        self.scheduleStore.updateSchedule(data, index);
        let parent = getParent(self, 1);
        if (parent) {
          parent.newSplitUpdateBySchedule();
          // parent.updateSplitRequests("lessonDays");
        }
      },
      saveRequestToServer,
      setLoading(state) {
        self.loading = state;
      },
      onUpdateRequestSplit(dd?: any) {},
      initializeRequestData,
      mapToStore,
      updateAdminLogin(value) {
        self.isAdminLogin = value;
      },
      updateLoggedIn(value) {
        self.isLoggedIn = value;
      },
      updateSelectedTutors(data, index) {
        let selectedTutors = [];
        self.splitRequests.forEach((o, i) => {
          if (i == index) {
            selectedTutors[i] = data;
          } else {
            selectedTutors[i] = getSnapshot(self.selectedTutors)[i];
          }
        });
        self.selectedTutors = cast(selectedTutors);
      },
      removeSelectedTutor(index) {
        let selectedTutors = [];
        self.splitRequests.forEach((o, i) => {
          if (i === index) {
            selectedTutors[i] = undefined;
          } else {
            selectedTutors[i] = getSnapshot(self.selectedTutors)[i];
          }
        });
        self.selectedTutors = cast(selectedTutors);
      },
    };
  });

export default RequestFlowStore;
